import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '@zendeskgarden/react-grid';
import { capitalize, round } from 'lodash';

import { elementShape } from 'propTypesObjects';
import { ElementBlockWrapper } from './ElementBlock.styles';

function ElementBlock({
  elementNumber,
  elements,
  minWidth,
  abbreviation,
  elementName,
  min,
  max,
}) {
  return (
    <ElementBlockWrapper
      className="element"
      elementNumber={elementNumber}
      elements={elements}
      minWidth={minWidth}
    >
      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className="symbol">{abbreviation}</div>
        <div className="at_num">{elementNumber}</div>
      </Row>
      <Row>
        <div className="elem_name">{capitalize(elementName)}</div>
      </Row>
      <Row>
        <div className="range">
          {min ? `${(round(min, 1) * 1).toString()}% - ` : <span>&le; </span>}
          {max ? `${(max * 1).toString()}%` : '×'}
        </div>
      </Row>
    </ElementBlockWrapper>
  );
}

ElementBlock.propTypes = {
  elementNumber: PropTypes.number,
  elements: PropTypes.arrayOf(elementShape),
  minWidth: PropTypes.string,
  abbreviation: PropTypes.string,
  elementName: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
};

export default ElementBlock;
